import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./contact.css";

export default function Contact() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("idle"); // idle | sending | error
  const beerIcon = "/icons/beer.png";

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    const form = e.target;
    const formData = new FormData(form);

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => navigate("/thanks"))
      .catch(() => setStatus("error"));
  };

  return (
    <main className="page contact-page">
      <section className="panel contact-panel">
        <h1>Contact</h1>
        <p className="muted">Have a beer <img src={beerIcon} alt="Beer" className="beer-icon" /> and say hi.</p>

        <form
          className="contact-form"
          name="contact"
          method="POST"
          data-netlify="true"
          netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
        >
          {/* Required for Netlify Forms */}
          <input type="hidden" name="form-name" value="contact" />

          {/* Honeypot */}
          <p className="hidden">
            <label>
              Don’t fill this out: <input name="bot-field" />
            </label>
          </p>

          <div className="row">
            <label className="label" htmlFor="name">
              Name
            </label>
            <input className="input" id="name" type="text" name="name" required />
          </div>

          <div className="row">
            <label className="label" htmlFor="email">
              Email
            </label>
            <input className="input" id="email" type="email" name="email" required />
          </div>

          <div className="row">
            <label className="label" htmlFor="message">
              Message
            </label>
            <textarea className="textarea" id="message" name="message" rows="6" required />
          </div>

          <div className="actions">
            <button className="button" type="submit" disabled={status === "sending"}>
              {status === "sending" ? "Sending…" : "Send"}
            </button>

            {status === "error" && (
              <span className="form-error">Something went wrong. Try again.</span>
            )}
          </div>
        </form>
      </section>
    </main>
  );
}